import APIClient from '@/shared/http/clients/api'

const resourceName = 'garantia-operacoes'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

/**
 * @name OperationsGuaranteeRepository
 * @description Garantia de operações
 * @type { Respository }
 */
const OperationsGuaranteeRepository = {
  Search
}

export default OperationsGuaranteeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/operationsguarantee.js